import { render } from "./AddressEdit.vue?vue&type=template&id=4c79642b"
import script from "./AddressEdit.vue?vue&type=script&lang=js"
export * from "./AddressEdit.vue?vue&type=script&lang=js"

import "./AddressEdit.vue?vue&type=style&index=0&id=4c79642b&lang=less"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__